module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_vm._v("contents")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/intro.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p01.htm#pt01"
    }
  }, [_vm._v("Beautiful Bags")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("Pretty Oriental Purse")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("Oh So Versatile Handbag")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("My Best Jumper Bag")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("Girl About Town Carryall")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p02.htm#pt02"
    }
  }, [_vm._v("Gorgeous Gifts")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("All Wrapped Up")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("Scent With Love")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("Music To Go")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("Fancy Stitching")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/p03.htm#pt03"
    }
  }, [_vm._v("Perfect Pillows")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("Quilt-Effect Cushion")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("Free As A Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("Vibrant Cushions")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("Childhood Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm#tec"
    }
  }, [_vm._v("Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("Templates")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("Designer Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/5-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-340136e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0